import React from 'react';

/**
 * DonutChart - Grafico de rosca para distribuicao
 * Componente reutilizavel para dashboards
 */

const DonutChart = ({
  data,
  size = 180,
  strokeWidth = 25,
  centerText,
  centerSubtext,
  showLegend = true,
}) => {
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const center = size / 2;

  let accumulatedOffset = 0;

  const calculateSegments = () => {
    return data.map((item, index) => {
      const percentage = item.value / 100;
      const segmentLength = circumference * percentage;
      const offset = circumference - accumulatedOffset;
      accumulatedOffset += segmentLength;

      return {
        ...item,
        strokeDasharray: `${segmentLength} ${circumference - segmentLength}`,
        strokeDashoffset: offset,
        rotation: -90,
      };
    });
  };

  const segments = calculateSegments();

  return (
    <div style={styles.container}>
      <div style={{ ...styles.chartContainer, width: size, height: size }}>
        <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
          {/* Background circle */}
          <circle
            cx={center}
            cy={center}
            r={radius}
            fill="none"
            stroke="#f0f0f0"
            strokeWidth={strokeWidth}
          />
          {/* Data segments */}
          {segments.map((segment, index) => (
            <circle
              key={index}
              cx={center}
              cy={center}
              r={radius}
              fill="none"
              stroke={segment.color}
              strokeWidth={strokeWidth}
              strokeDasharray={segment.strokeDasharray}
              strokeDashoffset={segment.strokeDashoffset}
              transform={`rotate(${segment.rotation} ${center} ${center})`}
              style={{
                transition: 'stroke-dasharray 0.5s ease, stroke-dashoffset 0.5s ease',
              }}
            />
          ))}
        </svg>
        {/* Center text */}
        <div style={styles.centerContent}>
          {centerText && (
            <span style={{ ...styles.centerText, fontSize: size * 0.15 }}>
              {centerText}
            </span>
          )}
          {centerSubtext && (
            <span style={styles.centerSubtext}>{centerSubtext}</span>
          )}
        </div>
      </div>

      {/* Legend */}
      {showLegend && (
        <div style={styles.legend}>
          {data.map((item, index) => (
            <div key={index} style={styles.legendItem}>
              <div style={{ ...styles.legendColor, backgroundColor: item.color }} />
              <span style={styles.legendLabel}>{item.label}</span>
              <span style={styles.legendValue}>{item.value}%</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
  },
  chartContainer: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  centerContent: {
    position: 'absolute',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
  centerText: {
    fontWeight: '700',
    color: '#333',
    lineHeight: 1,
  },
  centerSubtext: {
    fontSize: '12px',
    color: '#999',
    marginTop: '4px',
  },
  legend: {
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
    width: '100%',
  },
  legendItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
  },
  legendColor: {
    width: '12px',
    height: '12px',
    borderRadius: '3px',
    flexShrink: 0,
  },
  legendLabel: {
    flex: 1,
    fontSize: '13px',
    color: '#666',
  },
  legendValue: {
    fontSize: '13px',
    fontWeight: '600',
    color: '#333',
  },
};

export default DonutChart;
